import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=4daa1912&scoped=true&"
import script from "./Finalize.vue?vue&type=script&lang=js&"
export * from "./Finalize.vue?vue&type=script&lang=js&"
import style0 from "./Finalize.vue?vue&type=style&index=0&id=4daa1912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa1912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4daa1912')) {
      api.createRecord('4daa1912', component.options)
    } else {
      api.reload('4daa1912', component.options)
    }
    module.hot.accept("./Finalize.vue?vue&type=template&id=4daa1912&scoped=true&", function () {
      api.rerender('4daa1912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/checklist/Finalize.vue"
export default component.exports